export default __webpack_public_path__ + "static/media/next_disabled.e5e1bb64.svg";